import AdminSettingsBlock from "../../components/personal/AdminSettingsPage/AdminSettingsBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const AdminSettingsPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Страница администратора"}>
            <AdminSettingsBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default AdminSettingsPage;